module.exports = __webpack_public_path__ + "static/media/send_to.65b7d24e.svg";